import React, { ReactNode } from 'react';

const WorkforceSectionContainer: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <div className='relative flex h-[400px] w-full flex-col gap-16 overflow-hidden rounded-2xl bg-white'>
      {children}
    </div>
  );
};

export { WorkforceSectionContainer };
